import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

// i18n must be initialized before rendering so translations are available
import '@/core/i18n/i18n'

import App from '@/app/App'
import { initializeMonitoring, sentryReactErrorHandler } from '@/core/monitoring/sentry'

import '@/app/styles/index.css'

initializeMonitoring()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

createRoot(rootElement, {
  onUncaughtError: sentryReactErrorHandler(),
  onCaughtError: sentryReactErrorHandler(),
  onRecoverableError: sentryReactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
